import React, { Component } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import BasicButton from "../../../components/SharedComponents/BasicButton/BasicButton";
import BasicTextField from "../../../components/SharedComponents/BasicTextField/BasicTextField";
import BasicCheckbox from "../../../components/SharedComponents/BasicCheckbox/BasicCheckbox";
import BasicLabel from "../../../components/SharedComponents/BasicLabel/BasicLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import BasicTextArea from "../../../components/SharedComponents/BasicTextArea/BasicTextArea";
import SelectField from "../../../components/SharedComponents/SelectField/SelectField";
import SearchSelectField from "../../../components/SharedComponents/SearchSelectField";
import "./MixDateReport.scss";
import TableComponent from "../../../components/SharedComponents/Table";
import {
  agentListConfig,
  allContactList,
  reportConfig,
  allreportList,
  initialIntlTVDistributionProjection
} from "../Reports/config";
import Radio from "@material-ui/core/Radio";
import DateField from "../../../components/SharedComponents/DateField/DateField";
import clearTrackService from "../../../services/service";
import * as Constants from "../../../constants/constants";
import { withUserContext } from "../../../contexts/UserContext";
import ShowSeason from "./ShowSeason";
import Chip from "@material-ui/core/Chip";

class IntlTVDistributionProjection extends Component {
  constructor() {
    super();
    this.state = {
      postInitiated: false,
      renderList: allContactList,
      config: agentListConfig,
      renderList1: allreportList,
      config1: reportConfig,
      intlTVDistributionProjection: initialIntlTVDistributionProjection,
      seasonOption: [],
      showOptions: [],
      filterValues: [],
      removedItem: null,
      seasonIdValues: [],
      showIdValues: []
    };
  }

  handleSubmitTVDistributionProjectionReport = () => {
    this.setState({ postInitiated: true, isPosting: true });
    let { musicReplacementDomainDetails, filterValues, seasonIdValues, showIdValues } = this.state;
    let payload = {
      mix_date_start: mixDateDetails.mix_date_range_form,
      mix_date_end: mixDateDetails.mix_date_range_to,
      season_ids: seasonIdValues,
      show_ids: showIdValues
    }
    this.props.generateReport(this.props?.reportName, payload).then(response => {
      if (response.data.error) {
        // this.setState({ isPosting: false })
        // this.props.fieldChanged(true, "reportNotFound");
      }
      else {
        let url = response.data;
        let obj = {
          reportName: this.props?.reportDownloadName,
          production: "",
          season: "",
          episode: "",
          performer: "",
        }
        // this.setState({ isPosting: false })
        let reportNameFinal = genReportName(obj)
        this.props?.downloadUrl(url, reportNameFinal)
      }
    }, (err) => {
      this.setState({ isPosting: false })
      console.log(err)
      // this.props.fieldChanged(true, "reportFail");
    })
  }


  handleChange = (field, value) => {
    this.setState((prevState) => ({
      intlTVDistributionProjection: {
        ...prevState.intlTVDistributionProjection,
        [field]: value,
      },
    }));
  };

  handleFilterValues = (filterValues) => {
    let values = this.state.filterValues;
    values = filterValues
    this.setState({
      filterValues: values
    })
  }

  setSeasonId = (seasonIdValues) => {
    let seasonIdValue = this.state.seasonIdValues;
    seasonIdValue = seasonIdValues;
    this.setState({
      seasonIdValues: seasonIdValue
    })
  }

  setShowId = (showIdValues) => {
    let showIdValue = this.state.showIdValues;
    showIdValue = showIdValues;
    this.setState({
      showIdValues: showIdValue
    })
  }

  handleFilterDelete = (removeNode, index) => {
    let filterValues = this.state.filterValues;
    let removedItem = filterValues.splice(index, 1);
    this.setState({ filterValues: filterValues, removedItem: removeNode });
  }

  GenerateCleranceDetails = () => { };
  render() {
    return (
      <>
        {" "}
        <p>
          <b>Intl. TV Distribution - Summary Projections</b>
        </p>
        <MDBRow className={this.state.filterValues?.length > 0 ? "columnFilters d-block" : "d-none"}>
          <div style={{ display: "flex" }}>
            {this.state.filterValues &&
              this.state.filterValues?.map((item, index) => (
                <Chip
                  label={item}
                  onDelete={this.handleFilterDelete.bind(
                    this,
                    item,
                    index
                  )}
                // filterValues={this.state.filterValues}
                />
              ))}
          </div>
        </MDBRow>
        <MDBContainer
          style={{ background: "white" }}
          fluid
          className="MixDate-Container"
        >
          <MDBRow>
            <MDBCol md={7}>
              <ShowSeason
                onChangeCallBack={this.handleFilterValues}
                removedItem={this.state.removedItem}
                setSeasonId={this.setSeasonId}
                setShowId={this.setShowId} />
            </MDBCol>
            {/* <MDBCol md={3}>
              <BasicLabel text="Seasons" />
              <SearchSelectField
                id={"All Seasons"}
                placeHolderText={"All Seasons"}
                value={{ 'value': this.state.intlTVDistributionProjection.selected_season?.value, 'text': this.state.intlTVDistributionProjection.selected_season?.text } || {}}
                options={this.state.seasonOption || []}
                onChange={(e, value) => this.handleChange("selected_season", value)}
              />
            </MDBCol>
            <MDBCol md={3}>
              <BasicLabel text="Shows" />
              <SearchSelectField
                id={"All Shows in selected season(s)"}
                placeHolderText={"All Shows in selected season(s)"}
                value={{ 'value': this.state.intlTVDistributionProjection.selected_shows?.value, 'text': this.state.intlTVDistributionProjection.selected_shows?.text } || {}}
                options={this.state.showOptions || []}
                onChange={(e, value) => this.handleChange("selected_shows", value)}
              />
            </MDBCol> */}
            <MDBCol md={2}>
              <br />
              <BasicCheckbox
                id="Include Inactive Shows"
                label={"Include Inactive Shows"}
                checked={this.state.intlTVDistributionProjection?.is_include_inactive_shows || false}
                onChange={(e) => this.handleChange('is_include_inactive_shows', e.target.checked)}
              />
            </MDBCol>
          </MDBRow>
          <br />
        </MDBContainer>
        <MDBRow>
          <MDBCol md={9}></MDBCol>
          <MDBCol md={3}>
            <MDBRow>
              <MDBCol id="genpdf-btn">
                <br />
                <BasicButton className="efcBtn" text={"Generate PDF"} onClick={this.handleSubmitTVDistributionProjectionReport} />
              </MDBCol>
              <MDBCol>
                <br />
                <BasicButton variant="outlined" text={"Clear Filters"} />
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </>
    );
  }
}

export default withUserContext(IntlTVDistributionProjection);
